// filepath: apps/web/src/features/admin/secrets/SecretReferencesRoute.tsx
//
// FR-UI-ADM-10 AC-6 -- route shell for the secret reference admin
// editor.
//
// URL: /admin/secrets
//
// The route enforces the staging-only gate at the SPA layer
// (defense-in-depth; the server rejects production writes with
// HTTP 403 ENV_PRODUCTION on POST/DELETE).

import React from "react";
import { StagingOnlyError } from "@/features/admin/StagingOnlyError";
import { SecretReferencesPage } from "./SecretReferencesPage";

interface SecretReferencesRouteProps {
  /** Resolved environment kind from /api/tenant-config. */
  environmentKind: string;
}

export function SecretReferencesRoute({
  environmentKind,
}: SecretReferencesRouteProps): React.ReactElement {
  if (environmentKind !== "staging") {
    return <StagingOnlyError environmentKind={environmentKind} />;
  }
  return <SecretReferencesPage environmentKind={environmentKind} />;
}
